module.exports = __webpack_public_path__ + "05_long_brown.d5da0f1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/05_long_brown.png
// module id = +s1c
// module chunks = 0